import React from "react";
import ReactDOM from "react-dom/client";

export default function Footer() {
  return (
    <div class="container bottom_border foot">
      <div class="row">
        <div class=" col-sm-4 col-md col-sm-4  col-12 col">
          <h5 class="headin5_amrc col_white_amrc pt2">Find us</h5>

          <p class="mb10">
            Casino.org is the world’s leading independent online gaming
            authority, providing trusted online casino news, guides, reviews and
            information since 1995. Casino games typically provide a predictable
            long-term advantage to the casino, or "house", while offering the
            players the possibility of a short-term gain that in some cases can
            be large. YOU ARE IN SAFE HANDS.
          </p>
          <p>
            <i class="fa fa-location-arrow"></i> 9878/25 New Delhi plot 34 India{" "}
          </p>
          <p>
            <i class="fa fa-phone"></i> +91-9993487838{" "}
          </p>
          <p>
            <i class="fa fa fa-envelope"></i> info@example.com{" "}
          </p>
        </div>
      </div>
    </div>
  );
}
